export default {
  getTableSettings: (state) => state.tableSettings,
  getIpAddresses: (state) => state.ipAddresses,
  getIsTableLoading: (state) => state.isTableLoading,
}
